/**
 * @generated SignedSource<<9f740f912662b6a76fc83cce6498f794>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetIssueSummary_widgetIssueSummary$data = {
  readonly id: string;
  readonly teams: ReadonlyArray<{
    readonly id: string;
    readonly unresolvedIssueCount: number;
    readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueSummaryTeamItem_team">;
  }>;
  readonly title: string;
  readonly " $fragmentType": "WidgetIssueSummary_widgetIssueSummary";
};
export type WidgetIssueSummary_widgetIssueSummary$key = {
  readonly " $data"?: WidgetIssueSummary_widgetIssueSummary$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetIssueSummary_widgetIssueSummary">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetIssueSummary_widgetIssueSummary",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "teams",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unresolvedIssueCount",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetIssueSummaryTeamItem_team"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetIssueSummary",
  "abstractKey": null
};
})();

(node as any).hash = "259507e6d1047a8907586675a39d1e0d";

export default node;
